module.exports = __webpack_public_path__ + "static/assets/01d2f7a2918d702135f9e1f24d6a35e3.png";